module.exports = __webpack_public_path__ + "media/images/icons/outlined/api-1964c560ed2710a2f7092c259b7a4ed1.svg";